<template>
  <a
    class="project-card"
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div class="thumbnail">              
      <img
        :src="imageSrc"
        :alt="altText"
        @error="onImageError"
      />
    </div>
    <div class="project-content">
      <div class="text-content">
        <h3 class="project-title">{{ title }}</h3>
        <p class="project-subtitle">{{ subtitle }}</p>
      </div>
      <div class="arrow">
        <img src="../assets/right-up.png" alt="open" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    image: String,
    title: String,
    subtitle: String,
    url: String,
    altText: {
      type: String,
      default: 'Project Image'
    }
  },
  computed: {
    imageSrc() {
      if (!this.image) return ''
      if (/^https?:\/\//i.test(this.image)) {
        return this.image
      }
      try {
        return require(`@/assets/projects/${this.image}`)
      } catch (e) {
        console.error('Project image not found:', this.image)
        return ''
      }
    }
  },
  methods: {
    onImageError(event) {
      console.error('Image failed to load:', event.target.src);
    }
  }
}
</script>

<style scoped>
.project-card {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 40px;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
  padding: 20px;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: inherit;
}

.thumbnail {
  width: 80px;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.thumbnail img {
  width: 100%;
  display: block;
}

.project-card:hover {
  border-color: #9d6cf0;
}

.project-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
}

.text-content {
  text-align: left;
}

.project-title {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: white;
}

.project-subtitle {
  margin: 0;
  font-size: 1rem;
  color: #bbb;
}

.arrow img {
  width: 12px;
  height: 12px;
}

@media screen and (max-width: 1000px) {
  .tech-stack {
    flex-direction: column;
  }
}
</style>
